module.exports = __webpack_public_path__ + "static/media/craft_loading.be3268c3.mp3";